import { render, staticRenderFns } from "./CardSelectProperty.vue?vue&type=template&id=b2af22e4&"
import script from "./CardSelectProperty.vue?vue&type=script&lang=ts&"
export * from "./CardSelectProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports